<div class="huddle-suggestion-edit-panel" [class.show]="showEditModal">
    <div class="huddle-suggestion-edit-modal">
      <div class="suggestion-edit-modal-header">
        <div class="modal-header-text">{{modalHeader}}</div>
        <button class="modal-header-close-btn" (click)="closeEditModal()">
            <img src="assets/images/close.svg">
        </button>
      </div>
      <div class="suggestion-edit-modal-body" id="suggestion-edit-modal-body">
        <div id="huddle_merge_escalation_container"></div>
      </div>
      <div class="suggestion-edit-modal-footer" [class.shadow]="isScrollEnabled()">
        <div class="footer-buttons">
          <button class="cancel-btn" (click)="cancel()">Cancel</button>
          <button class="apply-btn"  (click)="triggerMerge()">{{this.escalationDetail.mode}}</button>
        </div>
      </div>
    </div>
  </div>